<template>
  <div id="app">

    <b-badge v-if="badgeEnv" variant="danger" class="badge-env"> {{ badgeEnv }} </b-badge>

    <!-- Burger menu responsive -->

    <button class="d-md-none btn btn-primary burger-toggle" @click="toggleMenu"><i class="ph ph-list"></i>

    </button>

    <!-- Pages without sidebar and navbar -->
    <div v-if="hideNavigation">
      <div>
        <router-view/>
      </div>
    </div>

    <!-- Pages with sidebar and navbar -->
    <div v-else>
      <div class="row no-gutters">
        <!-- sidebar -->
        <div class="responsive-menu col-md-3 col-lg-2" :class="{show: burgerToggle}">
          <div id="sidebar">
            <div class="sidebar-header mt-3">
              <img class="sidebar-header-logo text-left" :src="require(`@/assets/images/b122/sidebar-logo.png`)" alt="Logo"/>
              <div class="sidebar-header-title">{{ $t('loginTitle2') }}</div>
            </div>
            <div class="sidebar-secondary-header mt-3 ml-3 mr-3 pt-3 pb-3">
              <div class="sidebar-secondary-header-title text-left mb-2">Cinquième édition</div>
              <div class="text-left">Du 19 novembre au 3 décembre 2026</div>
            </div>

            <b-nav vertical class="sidebar-list mt-3">
              <SideMenu
                :links="sidebarLinks"
                :underlinks="sideBarUnderlinks"
                @toggle-burger="burgerToggle = !burgerToggle"
                :active-report-bug="activeReportBug"
                @showReportBugModal="showReportBugModal">
              </SideMenu>
            </b-nav>
            <button class="btn btn-closeMenu d-md-none" @click="toggleMenu"><i class="ph ph-x"></i>

            </button>
          </div>
        </div>

        <!-- navbar -->
        <div class="col-12 col-md-9 col-lg-10">

          <div class="page-container">
            <router-view/>
            <div class="main-footer" >
              <p>Copyright &#169; 2024 {{ $t('TitleProjectUC') }}.
                <span style="white-space: nowrap;">All rights reserved.</span>
              </p>
              <p style="white-space: nowrap;">Made with <heart-icon class="text-danger"/> by <a href="https://www.bleu122.com/" target="_blank" >Bleu122</a></p>
            </div>
          </div>

        </div>
      </div>
    </div>

    <show-bug-report-modal></show-bug-report-modal>

  </div>

</template>

<script>

import SideMenu from './views/menus/SideMenu'
import api from './services/api'
import ShowBugReportModal from "./components/b122/ShowBugReportModal";
import * as Sentry from "@sentry/vue";
import {bus} from "./main";


export default {

  name: 'App',

  components: {
    SideMenu,
    ShowBugReportModal,
  },

  data () {
    return {
      badgeEnv: null,
      burgerToggle: false,
    }
  },
  computed: {

    hideNavigation () {
      return !this.$store.getters.isAuthenticated
    },

    sidebarLinks () {
      return [
        {
          'icon': 'ph-calendar',
          'title': this.$store.getters.isUser? this.$i18n.t('MyProjects'): this.$i18n.t('Projects'),
          'route': '/project/index',
          'routesActiveItem': ['/project/show', '/project/create', '/project/edit', '/'],
          'isExpendable': false,
          'hidden': false
        },
        {
          'icon': 'ph-stack',
          'title': this.$i18n.t('Commissions'),
          'route': '/commission/index',
          'routesActiveItem': ['/commission/edit', '/commission/create'],
          'isExpendable': false,
          'hidden': !this.$store.getters.isAdmin
        },
        {
          'icon': 'ph-books',
          'title': this.$i18n.t('ProjectTypes'),
          'route': '/projecttype/index',
          'routesActiveItem': ['/projecttype/edit', '/projecttype/create'],
          'isExpendable': false,
          'hidden': !this.$store.getters.isAdmin
        },
        {
          'icon': 'ph-user-list',
          'title': this.$i18n.t('Users'),
          'route': '/user/index',
          'routesActiveItem': ['/user/show', '/user/create', '/user/edit'],
          'isExpendable': false,
          'hidden': !this.$store.getters.isAdmin
        },
        {
          'icon': 'ph-user-circle',
          'title': this.$i18n.t('Account'),
          'route': '/account/show',
          'routesActiveItem': ['/account/show', '/account/edit'],
          'isExpendable': false,
          'hidden': false
        }
      ]

    },

    sideBarUnderlinks () {
      return [
        []
      ]
    },

    activeReportBug(){
      return ['preprod', 'production'].includes(process.env.NODE_ENV)
    },

  },

  created() {
    bus.$on('showBugReportModal', () => {this.showReportBugModal()});
    const userProperties = [
      'username',
      'roles',
    ]
    const userForSentry = {};
    userProperties.forEach(key => {
      userForSentry[key] = this.$store.getters[key];
    });
    Sentry.setUser(userForSentry)
  },

  mounted () {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
    else {
      this.$i18n.locale = 'fr'
    }
    this.fetchEnvironment()
  },

  methods: {

    async logout () {
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    async fetchEnvironment() {
      const response = await api.get('/home/getEnvironmentName')
      let badgeStr = null
      if (response.data.toString() !== 'production') {
        badgeStr = response.data.toString().length > 7 ? response.data.toString().substring(0, 3).toUpperCase() : response.data.toString().toUpperCase()
      }
      this.badgeEnv = badgeStr
    },

    toggleMenu () {
      this.burgerToggle = !this.burgerToggle;
    },

    showReportBugModal(){
      this.$bvModal.show('show-bug-report-modal');
    }

  }

}
</script>

<style scoped>

.badge-env {
  padding: 8px;
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 10;
  font-size: 14px;
  background-color: var(--main-red);
}

#sidebar {
  position: relative;
  height: 100%;
  min-height: 100vh;
  padding-top: 20px;
  top: 0;
  z-index: 2;
}

.sidebar-header{
  display: flex;
  justify-content: center;
  flex-direction: row;
}

.sidebar-header-logo {
  display: flex;
  width: 50%;
}

.sidebar-header-title {
  display: flex;
  align-self: center;
  width: 50%;
  font-family: "SourceSerif4-Regular", "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  padding-right: 10px;
}

.sidebar-secondary-header {
  border-top: var(--main-border-color) var(--main-border-width) solid;
  border-bottom: var(--main-border-color) var(--main-border-width) solid;
}

.sidebar-secondary-header-title {
  font-family: "SourceSerif4-Regular", "Arial", sans-serif;
  font-size: var(--title-level-two-font-size);
  color: var(--secondary-color);
}

.main-footer{
  position: absolute;
  bottom: 0;
  width: 96%;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  margin: 0 2%;
  padding-top: 10px;
  border-top: 1px solid #D0CFCF;
}
.page-container{
  position: relative;
  min-height: calc(100vh - 2rem);
  padding-bottom: 3rem;
}
.content-wrap {
  padding-bottom: 3rem;    /* Footer height */
}

@media only screen and (max-width: 991px) and (min-width: 768px) {
  .main-footer{
    width: 96%;
    height: 3.5rem;
  }
  .content-wrap {
    padding-bottom: 3.5rem;    /* Footer height */
  }
}
@media only screen and (max-width: 767px) {
  .sidebar-header-logo {
    width: 100px;
  }
  .main-footer{
    width: 96%;
    font-size: 12px;
    height: 3.5rem;
  }
  .content-wrap {
    padding-bottom: 3.5rem;    /* Footer height */
  }
  .page-container{
    min-height: calc(100vh - 2rem);
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue